import { Box, Link } from '@montugroup/design-system';
import { styled } from '@mui/material/styles';
import logo from './montu.png';

const StyledHeader = styled(Box)(({ theme }) => ({
  top: 0,
  position: 'fixed',
  right: 0,
  left: 0,
  zIndex: theme.zIndex.appBar,
}));

const LogoImage = styled('img')(({ theme }) => ({
  maxWidth: 219,
  objectFit: 'contain',
  padding: 0,
  [theme.breakpoints.up('sm')]: {
    maxWidth: 230,
    padding: 0,
  },
  [theme.breakpoints.up('md')]: {
    maxWidth: 275,
    padding: theme.spacing(2),
  },
}));

const Header = () => {
  return (
    <StyledHeader data-testid="header">
      <Link href="https://www.montu.com.au" target="_blank" rel="noopener noreferrer">
        <LogoImage src={logo} alt="montu" />
      </Link>
    </StyledHeader>
  );
};

export default Header;
